import React from 'react';
import './App.css';
import { MainWrapper } from './Components/MainWrapper'

function App() {
    return (
        <div className="App">
            <MainWrapper />
        </div>
    );
}

export default App;
